export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14771.0ae96c9c.jpg";